'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const TimeLedgerPostingIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="TimeLedgerPostingIcon">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_451_5515)">
          <path
            d="M24.8652 12.8544C25.3559 15.4223 25.011 18.0799 23.8811 20.4376C22.7512 22.7952 20.8957 24.7289 18.5867 25.9551C16.2777 27.1813 13.6366 27.6355 11.0506 27.2512C8.46457 26.8669 6.0697 25.6642 4.21706 23.8195C2.36441 21.9749 1.15146 19.5852 0.756006 17.0009C0.360555 14.4165 0.803415 11.7735 2.01966 9.45922C3.2359 7.14495 5.16155 5.28117 7.51431 4.14113C9.86706 3.0011 12.5231 2.64476 15.0932 3.12438"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.8346 8.75V15.1667L8.88306 19.8322"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M27.4167 4.66659C27.4167 4.51188 27.3553 4.3635 27.2459 4.25411C27.1365 4.14471 26.9881 4.08325 26.8334 4.08325H23.9167V1.16659C23.9167 1.01188 23.8553 0.863503 23.7459 0.754106C23.6365 0.64471 23.4881 0.583252 23.3334 0.583252H21.0001C20.8454 0.583252 20.697 0.64471 20.5876 0.754106C20.4782 0.863503 20.4167 1.01188 20.4167 1.16659V4.08325H17.5001C17.3454 4.08325 17.197 4.14471 17.0876 4.25411C16.9782 4.3635 16.9167 4.51188 16.9167 4.66659V6.99992C16.9167 7.15463 16.9782 7.303 17.0876 7.4124C17.197 7.52179 17.3454 7.58325 17.5001 7.58325H20.4167V10.4999C20.4167 10.6546 20.4782 10.803 20.5876 10.9124C20.697 11.0218 20.8454 11.0833 21.0001 11.0833H23.3334C23.4881 11.0833 23.6365 11.0218 23.7459 10.9124C23.8553 10.803 23.9167 10.6546 23.9167 10.4999V7.58325H26.8334C26.9881 7.58325 27.1365 7.52179 27.2459 7.4124C27.3553 7.303 27.4167 7.15463 27.4167 6.99992V4.66659Z"
            stroke="#3D517B"
            strokeOpacity="0.56"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

TimeLedgerPostingIcon.propTypes = {
  sx: PropTypes.object
}
